<template>
  <section>
    <div class="row">
      <div :class="{ highligh: currentMonth == 12 }">
        <img src="../assets/december-blue.svg" />
        <div class="item">
          <span class="label blue">12月</span>
          <span>各私校考試團體報名開始</span>
        </div>
      </div>
      <div :class="{ highligh: currentMonth == 1 }">
        <img src="../assets/january-blue.svg" />
        <div class="item">
          <span class="label blue">1月</span>
          <span>6年級私校前哨戰</span>
        </div>
        <div class="item">
          <span class="label blue">1月寒假前</span>
          <span>3-5年級團體甄試</span>
        </div>
        <div class="item">
          <span class="label blue">1月下旬</span>
          <span>5-6年級寒密班開課</span>
        </div>
      </div>
      <div :class="{ highligh: currentMonth == 2 }">
        <img src="../assets/february-blue.svg" />
        <div class="item">
          <span class="label blue">2月下旬</span>
          <span>3-5年級高僑盃競試</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div :class="{ highligh: currentMonth == 3 }">
        <img src="../assets/march-red.svg" />
        <div class="item">
          <span class="label red">3月</span>
          <span>各私校入學考試</span>
        </div>
        <div class="item">
          <span class="label red">3月中旬</span>
          <span>5-6年級課程劃位</span>
        </div>
      </div>
      <div :class="{ highligh: currentMonth == 4 }">
        <img src="../assets/april-red.svg" />
        <div class="item">
          <span class="label red">4月上旬</span>
          <span>5-6年級課程開始</span>
        </div>
      </div>
      <div>
        <img src="../assets/may-red.svg" />
      </div>
    </div>
    <div class="row">
      <div :class="{ highligh: currentMonth == 6 }">
        <img src="../assets/june-green.svg" />
        <div class="item">
          <span class="label green">6月暑假前</span>
          <span>3-5年級團體甄試</span>
        </div>
        <div class="item">
          <span class="label green">3月6月中旬</span>
          <span>衛道科學班、衛道ESL班、明道拔尖班測驗</span>
        </div>
      </div>
      <div :class="{ highligh: currentMonth == 7 }">
        <img src="../assets/july-green.svg" />
        <div class="item">
          <span class="label green">7月上旬</span>
          <span>3-4年級課程開始</span>
        </div>
        <div class="item">
          <span class="label green">整個7月</span>
          <span>5-6年級暑密班第一梯次</span>
        </div>
      </div>
      <div :class="{ highligh: currentMonth == 8 }">
        <img src="../assets/august-green.svg" />
        <div class="item">
          <span class="label green">整個8月</span>
          <span>5-6年級暑密班第二梯次</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div :class="{ highligh: currentMonth == 9 }">
        <img src="../assets/september-yellow.svg" />
        <div class="item">
          <span class="label yellow">9月上旬</span>
          <span>私中衝刺班開課<br />3-5年級團體甄試</span>
        </div>
      </div>
      <div :class="{ highligh: currentMonth == 10 }">
        <img src="../assets/october-yellow.svg" />
        <div class="item">
          <span class="label yellow">10月中旬</span>
          <span>6年級高僑盃競試</span>
        </div>
      </div>
      <div :class="{ highligh: currentMonth == 11 }">
        <img src="../assets/november-yellow.svg" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      currentMonth: new Date().getMonth() + 1
    };
  }
};
</script>

<style lang="scss" scoped>
.row {
  border-bottom: 1px solid rgba(153, 158, 99, 0.34);
  display: flex;
  flex-direction: row;
  padding: 16px 0;
  margin: 0 44px;

  &:last-child {
    border-bottom: none;
  }

  > div {
    flex: 1;
    margin: 0 2px;
    padding: 27px 15px;

    img {
      display: block;
      margin-bottom: 15px;
    }
  }
}

.item {
  display: flex;
  margin-bottom: 10px;

  > span {
    display: block;
    font-weight: bold;
    font-size: 18px;
    color: #6b6b6b;
  }

  .label {
    text-align: center;
    border-radius: 5px;
    min-width: 90px;
    padding: 2px;
    font-size: 16px;
    color: white;
    margin-right: 9px;
    display: inline-table;

    &.blue {
      background-color: #1a5773;
    }
    &.red {
      background-color: #c96861;
    }
    &.green {
      background-color: #999e63;
    }
    &.yellow {
      background-color: #ebb300;
    }
  }
}

.highligh {
  background-color: #fffbe6;
  border-radius: 8px;
}

@media (max-width: 480px) {
  .row {
    flex-direction: column !important;
    border: none !important;
    margin: 0 !important;

    > div {
      margin-bottom: 40px;
      padding: 27px 40px;
    }
  }

  .highligh {
    border-radius: 0 !important;
  }
}
</style>
